import { IntlShape } from 'react-intl'

export const NUMBER_EXAMPLE = 9999.9

/**
 * CurrencyMaskSettings Interface
 */
export interface CurrencyMaskSettings {
  prefix?: string
  suffix?: string
  thousandSeparator?: string
  decimalSeparator: string
  /**
   * acceptable symbols that will be replaced by decimal separator
   */
  allowedDecimalSeparators?: Array<string>
  /**
   * decimal limit. if not defined then Infinity
   */
  decimalScale?: number
  allowNegative?: boolean
}

const defaultCurrencyMask: CurrencyMaskSettings = {
  prefix: '',
  suffix: '',
  thousandSeparator: '.',
  decimalSeparator: ',',
  allowedDecimalSeparators: ['.', ','],
  allowNegative: false,
}

/**
 * get currency mask settings by currency and intl
 */
export function getCurrencyMaskSettings(
  currency: string,
  intl: IntlShape,
  decimalScale: number | undefined = undefined
): CurrencyMaskSettings {
  const options: Partial<CurrencyMaskSettings> = {
    decimalScale,
  }

  const parts = intl.formatNumberToParts(
    NUMBER_EXAMPLE,
    currency
      ? {
          style: 'currency',
          currency,
        }
      : undefined
  )
  parts.forEach(({ type, value }) => {
    switch (type) {
      case 'group':
        options.thousandSeparator = value
        break
      case 'decimal':
        options.decimalSeparator = value
        break
      default:
        break
    }
  })

  return { ...defaultCurrencyMask, ...options }
}
